export default "/assets/images/badge-02.png?26d0a26348eb292e52ade2b1e4ecfa12";